module.exports = __webpack_public_path__ + "static/img/4596_phase_function_Paper_PointsHejduk_Prediction.a577fe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4596_phase_function_Paper_PointsHejduk_Prediction.png
// module id = QI0C
// module chunks = 0